import { SkeletonLoader } from "../../../SkeletonLoader";

/** Representative count — not tied to the eventual real row count (unknown
 * while still loading), matching PerformanceReport/mobile/MobileRowListSkeleton's
 * same fixed-count convention. */
const SKELETON_CARD_COUNT = 3;

/** One label→value skeleton row, standing in for a real `MobileFieldRow`. */
const SkeletonProgramFieldRow = () => (
  <div className="flex items-center justify-between gap-2">
    <SkeletonLoader height={14} width={88} variant="rounded" />
    <SkeletonLoader height={14} width={64} variant="rounded" />
  </div>
);

/**
 * Mobile program-list loading skeleton. Deliberately not
 * `TableMobileSkeletonLoader` — that one renders a bordered, rounded card
 * shaped like the Clients list, whereas `MobileProgramCard`'s real rows are
 * flush and divider-separated, so the shared loader visibly reflows the page
 * when data arrives (same reasoning as `PerformanceReport/mobile/
 * MobileRowListSkeleton.tsx`, which hit this identical mismatch first).
 *
 * Mirrors `MobileProgramCard`'s own structure: a two-line header (HOID,
 * then Sub IB names — the tag pills and chevron are deliberately omitted,
 * not every row has a tag and the chevron is decorative), then 3 field
 * rows — same gap-3 (header→fields), gap-2 (between fields), and py-4 card
 * inset, with every card's own bottom divider (including the last) rather
 * than TableMobile's `cellContainerClassName` override, since this skeleton
 * isn't rendered through `TableMobile` at all.
 */
export const MobileProgramCardSkeleton = () => (
  <div data-testid="mobile-program-card-skeleton">
    {Array.from({ length: SKELETON_CARD_COUNT }, (_, i) => (
      <div
        key={i}
        className="flex flex-col gap-3 border-b border-stroke-primary py-4"
      >
        <div className="flex min-w-0 flex-col gap-1">
          <SkeletonLoader height={16} width={80} variant="rounded" />
          <SkeletonLoader height={12} width={100} variant="rounded" />
        </div>
        <div className="flex flex-col gap-2">
          <SkeletonProgramFieldRow />
          <SkeletonProgramFieldRow />
          <SkeletonProgramFieldRow />
        </div>
      </div>
    ))}
  </div>
);
